import { APP_HEADER_ID, VIEW_TYPES } from "@/other/constants/OtherKeys.jsx";
import MainHeader from "./MainHeader.jsx";
import useViews from "../../hooks/useViews.jsx";

const AppHeader = () => {
  const viewManagerState = useViews();
  if (viewManagerState?.selectedView.viewType === VIEW_TYPES.mySwivu) return <></>;
  return (
    <div id={APP_HEADER_ID}>
      <div
        className="relative flex justify-between items-center min-h-[3.7em] px-3 bg-[#f1f1f1] dark:bg-[#181818] border-[0] border-b-[0.5px] border-b-[#f9f9f9] dark:border-b-[#000000] border-solid gap-3"
      >
        <MainHeader />
      </div>
    </div>
  );
};

export default AppHeader;
